import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class MaskingHelper {

    constructor() { }
  
    GetPhoneNoFormat(PhoneNo: string) {
      let PhoneNoMasked = PhoneNo === ''? '':PhoneNo.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, "$1-$2-$3");
      return PhoneNoMasked;
    }
  
    GetFaxNoFormat(FaxNo: string) {
      let FaxNoMasked = FaxNo === ''? '':FaxNo.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, "$1-$2-$3");
      return FaxNoMasked;
    }
  
    GetZipFormat(Zip: string) {
      if(Zip.length > 5){
        let ZipMasked = Zip === ''? '':Zip.replace(/^(.{0,3})(.{0,3})/, "$1 $2");
        return ZipMasked;
      }
      else{
        return Zip;
      }
    }

    GetFederalTaxFormat(Tax: string) {
      let TaxMasked = Tax === '' || Tax == null? '':Tax.replace(/^(.{0,2})(.{0,7})/, "$1-$2");
      return TaxMasked;
    }

    GetISNFormat(Tax: string) {
      let ISNMasked = Tax === '' || Tax == null? '':Tax.replace(/^(.{0,3})(.{0,6})/, "$1-$2");
      return ISNMasked;
    }
    
  }
  